@let interaction = inputData.$interaction();
<div class="alert max-w-screen w-[50rem] min-h-[20rem] flex flex-col justify-center items-center gap-[var(--gap-medium)] !mb-[var(--margin-medium)] !px-[var(--padding-medium)] !py-[var(--padding-medium)]" >
  <span class="icon-container" [innerHTML]="inputData.$icon()"></span>
  @if(inputData.$title() !== null) {
  <h2 class="title text-center">{{ inputData.$title() }}</h2>
  }
  @if (inputData.$message() !== null) {
  <h4 class="message text-center">{{ inputData.$message() }}</h4>
  }
  <div class="!pt-[1.7rem]">
   @if (interaction !== 'none') {
    <div class="flex flex-col justify-center gap-[var(--gap-medium)]">

      <!-- Botones de aceptar y cancelar -->
      <div class="flex justify-center gap-[var(--gap-medium)]">
        @if (interaction !== 'accept') {
        <app-button
          [text]="inputData.$cancelButton?.()?.text ?? t('cancel')()"
          [icon]="inputData.$cancelButton?.()?.icon ?? 'close-circle-outline'"
          gap="--gap-tiny"
          [textColor]="inputData.$cancelButton?.()?.textColor ?? '--danger'"
          [iconColor]="inputData.$cancelButton?.()?.iconColor ?? '--danger'"
          [iconScale]=".68"
          (click)="close(false)"
        />
        }
        <app-button
          [text]="inputData.$acceptButton?.()?.text ?? t('accept')()"
          [icon]="inputData.$acceptButton?.()?.icon ?? 'check-circle-outline'"
          gap="--gap-tiny"
          [textColor]="inputData.$acceptButton?.()?.textColor ?? '--secondary'"
          [iconColor]="inputData.$acceptButton?.()?.iconColor ?? '--secondary'"
          [iconScale]=".68"
          (click)="close(true)"
        />
      </div>
    </div>
   }
  </div>
</div>
